<template>
  <div>
    <div class="main-title">考试看板</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-select
              v-model="searchForm.company_ids"
              multiple
              placeholder="选择科目"
              @change="fetchList"
              style="width:250px;">
              <el-option
                v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        :data="list"
        stripe
        border
        :height="tableHeight"
        style="width:100%">
        <el-table-column
          prop="company_name"
          label="所属科目"
          width="100">
        </el-table-column>
        <el-table-column
          prop="car_alias"
          label="考试车号"
          sortable
          width="110">
        </el-table-column>
        <el-table-column
          prop="name_1"
          label="学员1"
          width="110">
        </el-table-column>
        <el-table-column
          prop="name_2"
          label="学员2"
          width="110">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import qs from 'qs'
export default {
  props: {
    tableHeight: Number
  },
  data () {
    return {
      list: [],
      searchForm: {
        company_ids: []
      },
      companyList: [],
      loading: false
    }
  },
  mounted () {
    this.fetchCompanyList()
  },
  methods: {
    async fetchCompanyList () { // 获取考场列表
      let response = await this.$http.get('/dbapi/company_combo')
      if (response.data.success) {
        this.companyList = response.data.list
        this.searchForm.company_ids = this.companyList.map(c => c.value)
        await this.fetchList()
      }
    },
    async fetchList () {
      this.loading = true
      let res = await this.$http.get('/dbapi/car_list', {
        params: {
          ...this.searchForm
        },
        paramsSerializer: function(params) {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        }
      })
      if (!res.data.success) {
        return
      }
      let list = res.data.list
      res = await this.$http.get('/dbapi/kc_exam', {
        params: {
          ...this.searchForm,
          daterange_start: moment().format('YYYY-MM-DD'),
          daterange_end: moment().format('YYYY-MM-DD 23:59:59')
        },
        paramsSerializer: function(params) {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        }
      })
      this.loading = false
      if (!res.data.success) {
        return
      }
      let exam_list = res.data.list
      exam_list.sort((a, b) => {
        return a.id - b.id
      })
      for (let i = 0; i < exam_list.length; i++) {
        if (exam_list[i].car_id > 0) {
          let index = list.findIndex(car => car.id == exam_list[i].car_id)
          if (index >= 0) {
            if (!list[index].name_1) {
              list[index].name_1 = exam_list[i].name
            } else {
              if (!!list[index].name_2) {
                list[index].name_1 = list[index].name_2
              }
              list[index].name_2 = exam_list[i].name
            }
          }
        }
      }
      this.list = list
    },
    refresh () {
      this.fetchList()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/exam/Car.vue